import { dayjsTz } from "@/app/_utils/dayjs";

export type ShowStatus =
  | "on-sale"
  | "almost-sold-out"
  | "sold-out"
  | "draft"
  | "past";

const ALMOST_SOLD_OUT_THRESHOLD = 0.85;

export function deriveShowStatus(show: {
  start?: string;
  end?: string;
  sold?: number;
  capacity?: number;
  published?: boolean;
}): ShowStatus {
  const now = dayjsTz();
  const end = show.end ? dayjsTz(show.end) : show.start ? dayjsTz(show.start) : null;
  if (end && end.isValid() && end.isBefore(now)) return "past";
  if (show.published === false) return "draft";

  const capacity = Number(show.capacity) || 0;
  const sold = Number(show.sold) || 0;
  if (capacity > 0 && sold >= capacity) return "sold-out";
  if (capacity > 0 && sold / capacity >= ALMOST_SOLD_OUT_THRESHOLD) return "almost-sold-out";
  return "on-sale";
}

export const SHOW_STATUS_LABEL: Record<ShowStatus, string> = {
  "on-sale": "On sale",
  "almost-sold-out": "Almost sold out",
  "sold-out": "Sold out",
  draft: "Draft",
  past: "Past",
};

export const SHOW_STATUS_DOT_CLASSES: Record<ShowStatus, string> = {
  "on-sale": "bg-emerald-500",
  "almost-sold-out": "bg-amber-500",
  "sold-out": "bg-red-500",
  draft: "bg-slate-400",
  past: "bg-muted-foreground/50",
};
